import { type AxiosPromise } from 'axios';

import { authBaseInstance, publicBaseInstance } from '@/lib/api/index';

export function createBonusProfile(cid: string, token: string): AxiosPromise<{}> {
  const url = 'public/api/demoPartner/create-bonus';
  return publicBaseInstance.post(url, {
    cid,
    token,
  });
}

export function getPlayerBonuses(params: { token: string; apiKey: string }): AxiosPromise {
  return authBaseInstance.post('/public/api/profile/bonus', params);
}
